import React from "react";

import FormControlLabel, {
  formControlLabelClasses,
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";
import { createStyles, withStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";

interface IProps extends FormControlLabelProps {}

export const AppFormControlLabel = withStyles(() =>
  createStyles({
    root: {
      gap: "12px",

      color: `${colors.gray600} !important`,
      textAlign: "center",
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
      margin: 0,

      [`& .${formControlLabelClasses.label}`]: {
        color: `${colors.gray600}`,
        textAlign: "center",
        fontFamily: "Manrope",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
      },
    },
  })
)(({ classes, control, label, labelPlacement, ...props }: IProps) => {
  return (
    <FormControlLabel
      label={label}
      control={control}
      labelPlacement={labelPlacement}
      classes={classes}
      {...props}
    />
  );
});
